import {ParameterDataType, SelectionType} from "./Category";
import type { CoverageArea } from "../utils/coverage";

/** Matches OpenAPI `InventoryCreationRequestDTO.visibility`. */
export enum Visibility {
    PUBLIC = "PUBLIC",
    PRIVATE = "PRIVATE",
}




/** Reference to a listing photo (bytes fetched from the photo url). */
export interface PhotoRef {
    photoId: string;
    contentType?: string;
    order: number;
}

export interface Inventory {
    id?: string;
    version?: string;
    visibility: Visibility;
    categoryId: string;
    inventoryName: string;
    /** Private, owner-only. */
    notes: string;
    /** Public, shown to searchers. */
    description: string;
    url: string;
    parameters: InventoryParameter[];
    /** Ordered photos attached to the listing. */
    photos?: PhotoRef[];
    /** Service-area coverage (empty for non-service listings). */
    coverage?: CoverageArea[];
    /** Fixed item location (only for categories with hasItemLocation). */
    location?: ItemLocation | null;
    /** The owning store's profile location (search results only) — the
     *  detail view's fallback when there's no coverage and no location. */
    storeLocation?: ItemLocation | null;
    /** The owning store's display name (search results only). */
    storeName?: string | null;
    /** The owning organization's id (search results only) — drives the
     *  claim-this-business banner for unclaimed managed orgs. */
    orgId?: number | null;
    /** The owning store's public contact details (search results only). */
    storeContact?: {
        phone?: string | null;
        email?: string | null;
        website?: string | null;
        whatsapp?: string | null;
    } | null;
  }

/** The fixed location of a listed item (apartment, room, house): geo id
 *  chain for hierarchical search, display label, optional street address
 *  (display only — never searched). */
export interface ItemLocation {
    countryId: number | null;
    admin1Id: number | null;
    admin2Id: number | null;
    cityId: number | null;
    /** e.g. "Austin, Texas, United States" */
    label: string | null;
    streetAddress1?: string | null;
    streetAddress2?: string | null;
}


export type FixedField = "Name" | "Notes" | "Description" | "Url" | "Visibility";

export type FieldChange = {
    field: FixedField;
    value: string | Visibility | null;
};
export interface InventorySummary {
    id: string;
    name: string;
    /** Public description shown to searchers. */
    description?: string;
    url: string;
    visibility: Visibility; // or Visibility enum if you prefer
    parameters: InventoryParameter[];
    photos?: PhotoRef[];
    coverage?: CoverageArea[];
}

export interface InventoryCreationRequest {
    categoryId: string;
    inventoryName: string;
    notes: string;
    description?: string;
    url: string;
    visibility: Visibility;
}

/** Metadata returned by the backend when an HTML document is attached to an item. */
export interface HtmlDocRef {
    fileId: string;
    fileName: string;
    sizeBytes: number;
    uploadedAt?: string;
    publicToken: string;
}

export interface InventoryParameter {
    id: number
    name: string;
    value: any;
    dataType: ParameterDataType | string; // allow string if backend sends plain string
    selectionType?: SelectionType;

    // Numeric (INTEGER/DOUBLE): the unit id the stated `value` is expressed in.
    units?: string;
    // DOUBLE only: the value expressed in every allowed unit, keyed by unit id.
    valueMap?: Record<string, number>;
}

